import { httpApi } from "api/http.api";
import { AxiosError, AxiosResponse } from "axios";

export const getLookupConfiguration = (sku: string, configurationId: string) => {
  return httpApi
    .get(`/rawlingsmylocker/lookupconfiguration/${sku}/${configurationId}`)
    .then((res) => {
      return res;
    })
    .catch((err: AxiosError) => {
      throw err;
    });
};

export const checkIsDesignIdExists = async (designId: string) => {
  const url = `rawlingsmylocker/isdesignidexist/${designId}`;
  return httpApi
    .get(url)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};
